<template>
	<div class="mt-4 lg:mt-0">
		<CartItems ref="cartItems">
			<!-- Physical Cart Items -->
			<!-- <div
				class="flex flex-col w-full justify-between py-3 px-4 border-ihh-gray/40"
				v-for="{ item, quantity, variant, group, optional } in displayedCartItems"
				:key="item.id"
			>
				<div class="">
					<div class="flex w-full items-center">
						<div class="justify-center text-center mr-6">
							<div class="flex justify-center items-center space-x-8 shrink-0 min-w-[70px] min-h-[70px]">
								<img class="max-w-[70px] max-h-[70px] object-contain" :src="variant?.imageUrl || item.images?.find((image) => image.isThumbnail)?.url" />
							</div>
						</div>

						<div class="flex flex-col w-full gap-y-2">
							<div class="w-full flex justify-between text-ihh-midnight-gray text-sm">
								<div class="flex flex-wrap line-clamp-2 max-w-[164px]">{{ quantity }} x {{ item.name }}</div>
								<div>${{ ((variant?.calculatedPrice?.toFixed?.(2) || item?.calculatedPrice?.toFixed(2)) * quantity).toFixed(2) }}</div>
							</div>
							<div v-if="variant" class="text-ihh-gray-700 px-2 text-xs">
								<div v-for="option in variant.optionValues">
									<span class="text-ihh-midnight-gray font-semibold">{{ `${option.optionDisplayName}: ` }}</span>
									<span class="text-ihh-gray-700 font-normal">{{ option.label }}</span>
								</div>
								<div v-if="XCoverProducts.includes(item?.bcId)">
									<span class="text-ihh-midnight-gray font-semibold">{{ `Covered Product Code: ` }}</span>
									<span class="text-ihh-gray font-normal">{{ optional?.coveredProductCode }}</span>
								</div>
								<div v-if="XCoverProducts.includes(item?.bcId)">
									<span class="text-ihh-midnight-gray font-semibold">{{ `Covered Product: ` }}</span>
									<span class="text-ihh-gray font-normal">{{ optional.productName }}</span>
								</div>
							</div>
							<div class="flex w-full justify-between sm:pt-4 lg:pt-0"></div>
						</div>
					</div>
				</div>
			</div> -->
			<div>
				<CheckoutCartItem
					v-for="{ item, quantity, variant, group, optional } in displayedCartItems"
					:key="item.id"
					:item="{ item, quantity, variant, group, optional }"
					:XCoverProducts="XCoverProducts"
				/>
			</div>

			<!-- Gift Certificates -->
			<!-- <div class="flex flex-col w-full justify-between py-3 px-4 border-ihh-gray/40" v-for="(cert, index) in store.cart.certificates" :key="'cert-' + index">
				<div class="">
					<div class="flex w-full items-center">
						<div class="justify-center text-center mr-6">
							<div class="flex justify-center items-center space-x-8 shrink-0 min-w-[70px] min-h-[70px]">
								<img
									class="max-w-[70px] max-h-[70px] object-contain"
									src="https://cdn11.bigcommerce.com/s-nuj3c/stencil/29299650-2b9e-013d-ca92-06d759ad9f37/e/15c6ecf0-25f0-013d-e4f6-1e7f4d7752a0/img/GiftCertificate.png"
								/>
							</div>
						</div>

						<div class="flex flex-col w-full gap-y-2">
							<div class="w-full flex justify-between text-ihh-midnight-gray text-sm">
								<div class="flex flex-wrap line-clamp-2 max-w-[164px]">1 x Gift Certificate</div>
								<div>${{ cert.amount?.toFixed?.(2) }}</div>
							</div>
							<div class="text-ihh-gray-700 px-2 text-xs">
								<div>
									<span>Recipient: </span>
									<span class="text-ihh-gray-700 font-normal">{{ cert?.recipient?.name }}</span>
								</div>
								<div>
									<span>Email: </span>
									<span class="text-ihh-gray-700 font-normal">{{ cert?.recipient?.email }}</span>
								</div>
							</div>

							<div class="flex w-full justify-between sm:pt-4 lg:pt-0"></div>
						</div>
					</div>
				</div>
			</div> -->
			<div>
				<CheckoutCartCertificate v-for="(cert, index) in store.cart.certificates" :key="'cert-' + index" :certificate="cert" :index="index" />
			</div>

			<div class="flex w-full justify-center border-ihh-gray/40" v-if="store?.cart?.cartItems?.length > 4">
				<button
					@click="showFullCart = !showFullCart"
					class="hover:bg-ihh-gray/10 hover:border-ihh-midnight-gray/50 flex my-5 items-center text-center text-sm text-ihh-midnight-gray border rounded-sm border-ihh-gray/50 py-1 px-4"
				>
					{{ showFullCart ? 'See Less' : 'See All' }}
					<span
						class="flex-inline m-auto items-center justify-center text-center transition duration-100 ease-in-out group"
						:class="{ 'rotate-180 pb-1': showFullCart }"
					>
						<svg class="w-6 h-6" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
							<polygon points="50,70 30,50 35,45 50,60 65,45 70,50" class="fill-ihh-gray" />
						</svg>
					</span>
				</button>
			</div>

			<!-- Show Empty Cart -->
			<div v-if="!store.cartTotalItems" class="w-full lg:w-96 border border-ihh-white py-8 space-y-6">
				<div class="text-center w-full text-ihh-gray-600 text-base">Your cart is empty!</div>
				<div class="flex w-full justify-center">
					<svg class="w-full max-w-52" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130 130">
						<g>
							<path
								style="fill: #453c50"
								d="M45.3 81.2h78V43.7L35.9 25.4l-3.1-12.9-12.6-4.2c0-.2.1-.3.1-.5 0-4.3-3.5-7.8-7.8-7.8S4.7 3.5 4.7 7.8s3.5 7.8 7.8 7.8c1.8 0 3.4-.6 4.7-1.6l9.4 4.7L39 78l-12.5 9.4V103l5.7 7.1c-1.6 1.9-2.5 4.3-2.5 7 0 6 4.9 10.9 10.9 10.9s10.9-4.9 10.9-10.9-4.9-10.9-10.9-10.9c-.9 0-1.8.1-2.6.3l-2.1-3.4h65.6l3.6 6c-2.2 2-3.6 4.9-3.6 8.1 0 6 4.9 10.9 10.9 10.9s10.9-4.9 10.9-10.9-4.9-10.9-10.9-10.9h-.3l-1.3-3.1h12.5V97H32.8v-6.2l12.5-9.6zm0-6.3-4.6-21.4.6 3L59.8 58l3.8 17H45.3zm21.8 0-3.7-16.7 18.1 1.4 1.4 15.3H67.1zm18.8 0-1.4-15 17 1.3v13.7H85.9zm31.2-15.6v15.6h-12.5V61.5l12.5 1v-3.2l-12.5-1V44.4l12.5 2.4v12.5zM35.9 31.2l65.6 12.6V58l-17.3-1.4-1.5-16.4-3.1-.6 1.6 16.8-18.5-1.5-4.3-19.3-3.7-.7 4.4 19.7-18.5-1.5-4.7-21.9zm76.5 81.2c2.6 0 4.7 2.1 4.7 4.7s-2.1 4.7-4.7 4.7-4.7-2.1-4.7-4.7 2.1-4.7 4.7-4.7zm-71.8 0c2.6 0 4.7 2.1 4.7 4.7s-2.1 4.7-4.7 4.7-4.7-2.1-4.7-4.7 2.1-4.7 4.7-4.7z"
							/>
						</g>
					</svg>
				</div>
			</div>

			<div v-if="store.cartTotalItems" class="flex-col w-full justify-between space-y-3 p-4 text-sm text-ihh-midnight-gray border-ihh-gray/40 border-t">
				<!-- Subtotal -->
				<div class="flex w-full justify-between text-ihh-midnight-gray">
					<div>Subtotal</div>
					<div>
						{{ (store.cart.subTotal || store.cartSubtotal).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}
					</div>
				</div>

				<!-- Shipping -->
				<div v-if="!isDigitalOnly" class="w-full flex m-auto items-center justify-between mb-1">
					<div class="flex-grow">
						<div class="">Shipping:</div>
					</div>
					<div class="w-16 text-right font-normal">{{ shippingText }}</div>
				</div>

				<!-- Tax -->
				<template v-if="checkout.isTexasShippingAddress">
					<div v-for="tax in taxes" class="flex m-auto items-center justify-between mb-1 w-full">
						<div class="whitespace-nowrap">{{ tax.name }}:</div>
						<Spinner v-if="store.cart.tax === null" :small="true" class="w-4 h-4" color="border-t-ihh-salmon" />
						<div v-else>
							{{ tax.amount?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}
						</div>
					</div>
				</template>

				<!-- Store Credit -->
				<div v-if="checkout.payment.useStoreCredit" class="flex w-full justify-between text-ihh-midnight-gray">
					<div>Store Credit:</div>
					<span>-{{ storeCreditAmount?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
				</div>

				<!-- Coupon Code -->
				<div class="w-full">
					<Coupon :style="couponStyle" />
				</div>

				<!-- Gift Certificate -->
				<div class="w-full">
					<Certificate :style="certificateStyle" />
				</div>
			</div>

			<div v-if="store.cartTotalItems" class="flex m-auto items-center w-full justify-between border-t p-4 text-ihh-midnight-gray">
				<div class="text-sm sm:text-base">Total (USD)</div>
				<Spinner v-if="store.cart.tax === null" :small="true" class="w-4 h-4" color="border-t-ihh-salmon" />
				<div class="text-2xl sm:text-3xl font-bold" v-else>
					{{ checkout.displayTotal?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}
				</div>
			</div>
		</CartItems>
	</div>
</template>

<script>
import CartItems from '../layout/cart-items.vue'
import Coupon from './coupon.vue'
import Certificate from './certificate.vue'
import CheckoutCartItem from '../layout/checkout-cart-item.vue'
import CheckoutCartCertificate from '../layout/checkout-cart-certificate.vue'
import { useCheckoutStore } from '../../stores/store.js'

export default {
	name: 'CheckoutCart',
	inject: ['store'],
	props: {
		isDigitalOnly: {
			type: Boolean,
			default: false,
		},
	},

	components: { CartItems, Coupon, Certificate, CheckoutCartItem, CheckoutCartCertificate },
	data() {
		return {
			showFullCart: false,
			couponStyle: {
				title: 'font-normal text-ihh-dark-salmon',
				remove: 'text-sm',
			},
			certificateStyle: {
				title: 'font-normal text-ihh-dark-salmon',
				remove: 'text-sm',
			},
			XCoverProducts: [3693, 3694, 3900, 3901],
			checkout: useCheckoutStore(),
		}
	},

	computed: {
		displayedCartItems() {
			return this.showFullCart ? this.store.cart.cartItems : this.store.cart.cartItems.slice(0, 4)
		},
		shippingText() {
			if (!this.checkout.shipping.selectedShipping?.id) return '--'
			const cost = this.checkout.shipping.selectedShipping?.cost
			return cost === 0 ? 'FREE' : cost?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
		},
		taxes() {
			return this.checkout.payment.taxes
		},
	},
}
</script>

<style scoped></style>
